/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ach/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Ach({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup/Pay/ChooseType/Widget/Ach"
  
}) {
let payersActivetabOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.organization_id',
})
let payersActivetabPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.payer_person',
})
  return (<React.Fragment
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="ach"
 data="payers.activeTab.organization_id"
 locationId={payersActivetabOrganizationIdValueData}
 data="payers.activeTab.payer_person"
 person={payersActivetabPayerPersonValueData}
/>
{children}
</React.Fragment>)
}